import React from 'react';
import _ from 'lodash';
import {Header, Icon} from 'semantic-ui-react';
import PropTypes from 'prop-types';

const CompanyShipStationHeader = ({model}) => (
    <div>
        <Header as='h2'>
            <Icon name='settings' />
            <Header.Content>
                Company ShipStation Store
                <Header.Subheader>Last Synchronize: {_.isObject(model.synchronize) ? model.synchronize.updated_at : null}</Header.Subheader>
            </Header.Content>
        </Header>
    </div>
)

CompanyShipStationHeader.propTypes = {
    model: PropTypes.object.isRequired
};


export default CompanyShipStationHeader